"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Label_1 = require("./Label");
const index_1 = require("./index");
const Title = (_a) => {
    var { type = "secondary", styleType, color, children, label, labelColor = "primary", elementType = "h", center } = _a, rest = __rest(_a, ["type", "styleType", "color", "children", "label", "labelColor", "elementType", "center"]);
    let obj;
    if (elementType === "h") {
        if (type === "primary") {
            obj = react_1.default.createElement(index_1.H1, Object.assign({ color: color, styleType: styleType !== null && styleType !== void 0 ? styleType : "primary" }, rest), children);
        }
        if (type === "secondary") {
            obj = react_1.default.createElement(index_1.H2, Object.assign({ color: color, styleType: styleType !== null && styleType !== void 0 ? styleType : "secondary" }, rest), children);
        }
        if (type === "third") {
            obj = react_1.default.createElement(index_1.H3, Object.assign({ color: color, styleType: styleType !== null && styleType !== void 0 ? styleType : "third" }, rest), children);
        }
    }
    else {
        if (type === "primary") {
            obj = react_1.default.createElement(index_1.LabelH1, Object.assign({ color: color, styleType: styleType !== null && styleType !== void 0 ? styleType : "primary" }, rest), children);
        }
        if (type === "secondary") {
            obj = react_1.default.createElement(index_1.LabelH2, Object.assign({ color: color, styleType: styleType !== null && styleType !== void 0 ? styleType : "secondary" }, rest), children);
        }
        if (type === "third") {
            obj = react_1.default.createElement(index_1.LabelH3, Object.assign({ color: color, styleType: styleType !== null && styleType !== void 0 ? styleType : "third" }, rest), children);
        }
    }
    return (react_1.default.createElement(Wrapper, { center: center, className: "title" },
        label && (react_1.default.createElement(Label_1.Label, { type: "third", margin: "0", color: labelColor, textTransform: "uppercase" }, label)),
        obj));
};
exports.Title = Title;
const Wrapper = styled_components_1.default.div `
  svg {
    width: ${({ theme }) => theme.font.XL};
    margin: auto 0;
    margin-right: 7px;
  }

  ${({ center }) => center &&
    (0, styled_components_1.css) `
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      * {
        text-align: center;
      }
    `};
`;
//# sourceMappingURL=Title.js.map